
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"62","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"2_SP_Comp","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","stroke-linejoin":"round"}},[_c('g',{attrs:{"id":"B.10_サイトトップ-#ログイン後","transform":"translate(-28 -648)","stroke-width":"2"}},[_c('g',{attrs:{"id":"施設を検索","transform":"translate(0 529)"}},[_c('g',{attrs:{"id":"Group-20","transform":"translate(29 120)"}},[_c('polygon',{attrs:{"id":"Path-5","stroke":"#000264","points":"30.5714266 53.8367527 30.5714266 46.1622242 16.4725207 46.1622242 16.4725207 37.203868 38.1812211 37.203868 38.1812211 30.3917588 44.0274831 30.3917588 44.0274831 18.2102518 55.0648097 18.2102518 55.0648097 46.8177958 49.9575625 46.8177958 49.9575625 50.4810642 38.1812211 50.4810642 38.1812211 53.8367527"}}),_c('polygon',{attrs:{"id":"Path-6","stroke":"#000264","points":"-1.8189894e-12 42.2224334 11.7003819 42.2224334 11.7003819 59.632874 2.29412649 59.632874 2.29412649 49.1613147 -1.8189894e-12 49.1613147"}}),_c('polygon',{attrs:{"id":"Path-7","stroke":"#198BDB","points":"15.4725207 49.0926432 15.4725207 54.8367527 27.7457793 54.8367527 27.7457793 49.0926432"}}),_c('polygon',{attrs:{"id":"Path-8","stroke":"#000264","points":"44.2899045 8.8817842e-16 44.2899045 15.1275397 48.8149203 15.1275397 48.8149203 13.7905777 61.6891196 13.7905777 61.6891196 8.8817842e-16"}})])])])])])
          )
        }
      }
    